module.exports = __webpack_public_path__ + "img/Med01.03-1-AileenMayHoward.c350414b.jpg";